const LTE_96 = 'LTE_96'
const RANGE_97_99 = 'RANGE_97_99'
const RANGE_100_125 = 'RANGE_100_125'
const GTE_126 = 'GTE_126'
const NOT_APPLICABLE = 'NOT_APPLICABLE'

const osi = {
  options: {
    NOT_APPLICABLE: {
      class: 'not-applicable',
      comparator: (value) => ((!value && value !== 0) || value === 'N/A'),
      operator: 'custom',
      parameters: [
        {
          operator: 'eq',
          text: 'N/A',
          value: 'N/A',
        },
      ],
      text: 'INCL N/A',
      value: NOT_APPLICABLE,
    },
    LTE_96: {
      class: 'lte-96',
      comparator: (value) => value >= 0 && value <= 96,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '0',
          value: 0,
        },
        {
          operator: 'lte',
          text: '96',
          value: 96,
        },
      ],
      text: 'GTE 0 AND LTE 96',
      value: LTE_96,
    },
    RANGE_97_99: {
      class: 'range-97-99',
      comparator: (value) => value >= 97 && value <= 99,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '97',
          value: 97,
        },
        {
          operator: 'lte',
          text: '99',
          value: 99,
        },
      ],
      text: 'GTE 97 AND LTE 99',
      value: RANGE_97_99,
    },
    RANGE_100_125: {
      class: 'range-100-125',
      comparator: (value) => value >= 100 && value <= 125,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '100',
          value: 100,
        },
        {
          operator: 'lte',
          text: '125',
          value: 125,
        },
      ],
      text: 'GTE 100 AND LTE 125',
      value: RANGE_100_125,
    },
    GTE_126: {
      class: 'gte-126',
      comparator: (value) => value >= 126,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '126',
          value: 126,
        },
      ],
      text: 'GTE 126',
      value: GTE_126,
    },
  },

  isOsiInRange(osiValue, osiOption) {
    const { options } = this
    const option = Object.keys(options).find((optionName) => {
      const { operator, value } = options[optionName]
      const { operator: optionOperator } = osiOption

      return [operator, value].includes(optionOperator)
    })

    if (!option) {
      if (osiOption.operator === 'eq') {
        return osiValue === osiOption.value
      }

      if (osiOption.operator === 'neq') {
        return osiValue !== osiOption.value
      }
    }

    return option.comparator(osiValue)
  },

  getOsiClassName(osiValue) {
    const { options } = this

    if (options.NOT_APPLICABLE.comparator(osiValue)) {
      return `osi ${options.NOT_APPLICABLE.class}`
    }

    if (options.LTE_96.comparator(osiValue)) {
      return `osi ${options.LTE_96.class}`
    }

    if (options.RANGE_97_99.comparator(osiValue)) {
      return `osi ${options.RANGE_97_99.class}`
    }

    if (options.RANGE_100_125.comparator(osiValue)) {
      return `osi ${options.RANGE_100_125.class}`
    }

    if (options.GTE_126.comparator(osiValue)) {
      return `osi ${options.GTE_126.class}`
    }

    return 'osi value-invalid'
  },
}

export default osi
